import React from "react";
import { BrowserRouter as Router } from "react-router";
import { createRoot } from "react-dom/client";
import { EventType, AuthenticationResult } from "@azure/msal-browser";
import { AccountInfo } from "@azure/msal-common";
import {
  msalInstance,
  basePath,
  consumeReturnPath,
  resetRedirectGuard,
} from "@/pages/Login/auth.config";
import { logMajorVersionMismatch } from "@/services/utils.ts";
import App from "./app/App.tsx";

// Stale ephemeral URL: staging build served at /eph/* means the environment was
// cleaned up or never existed (S3 404 → CloudFront fallback to staging index.html)
if (basePath === "/" && globalThis.location.pathname.startsWith("/eph/")) {
  document.getElementById("root")!.innerHTML =
    '<div style="font-family:sans-serif;padding:2rem;text-align:center;margin-top:4rem">' +
    "<h1>Ephemeral environment not found</h1>" +
    "<p>This environment may have been cleaned up or does not exist.</p>" +
    "</div>";
  throw new Error("Ephemeral environment not found");
}

msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts();

  const setUserAccount = (account: AccountInfo) => {
    msalInstance.setActiveAccount(account);
  };

  if (accounts.length > 0) {
    setUserAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      setUserAccount(account);
      resetRedirectGuard();

      const returnPath = consumeReturnPath();
      if (returnPath) {
        window.location.replace(returnPath);
      }
    }
  });

  logMajorVersionMismatch();

  const container = document.getElementById("root") as HTMLElement;
  createRoot(container).render(
    <React.StrictMode>
      <Router basename={basePath}>
        <App msalInstance={msalInstance} />
      </Router>
    </React.StrictMode>,
  );
});
